import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import b from 'b_';

import { getQueryValue } from 'client/components/filters/filters-query';
import ApiRequest from 'client/helpers/apiRequest';

const class_ = b.with('page');

interface State {
    isLoading: boolean;
    isConfirmed?: boolean;
}

export default class ConfirmationPage extends Component<RouteComponentProps, State> {
    state: State = {
        isLoading: true
    };

    componentDidMount() {
        const { location } = this.props;
        const query = getQueryValue(location.search);

        ApiRequest.get(`/api/confirmation/${query.token}`).then(
            () => this.setState({ isConfirmed: true, isLoading: false }),
            () => this.setState({ isConfirmed: false, isLoading: false }));
    }

    render() {
        const { isLoading, isConfirmed } = this.state;
        const message = isConfirmed
            ? 'Ваш email успешно подтвержден'
            : 'Ваш email уже был подтвержен ранее';

        return (
            <div className={class_({ type: 'home' })}>
                <h1>Подтверждение email</h1>
                <div>{isLoading ? 'Загрузка...' : message}</div>
            </div>
        );
    }
}
